// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flag-wave-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1 17V1' />
    <path
      fill='currentColor'
      d='M16.915 3.624a.76.76 0 0 0-.237-.283.883.883 0 0 0-.332-.15.82.82 0 0 0-.37.018l-1.687.48c-.91.254-1.867.33-2.806.198s-1.838-.452-2.654-.941a6.81 6.81 0 0 0-2.72-.95 6.89 6.89 0 0 0-2.872.244L1 2.927v9.985l2.246-.687a6.892 6.892 0 0 1 5.593.706c.806.49 1.706.819 2.654.941a6.89 6.89 0 0 0 2.806-.197l2.123-.603A.792.792 0 0 0 17 12.31V3.972a.794.794 0 0 0-.085-.358z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
